/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_Li_Incident_TextInputs */

const tr_servis_s4_li_incident_text = /** @type {(inputs: Servis_S4_Li_Incident_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` iş saatleri içinde 4 saat, dışında 12 saat`)
};

const en_servis_s4_li_incident_text = /** @type {(inputs: Servis_S4_Li_Incident_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 4 hours within business hours, 12 hours outside`)
};

const de_servis_s4_li_incident_text = /** @type {(inputs: Servis_S4_Li_Incident_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 4 Stunden innerhalb der Geschäftszeiten, 12 Stunden außerhalb`)
};

const ru_servis_s4_li_incident_text = /** @type {(inputs: Servis_S4_Li_Incident_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 4 часа в рабочее время, 12 часов вне рабочего времени`)
};

/**
* | output |
* | --- |
* | "4 hours within business hours, 12 hours outside" |
*
* @param {Servis_S4_Li_Incident_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_li_incident_text = /** @type {((inputs?: Servis_S4_Li_Incident_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_Li_Incident_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_li_incident_text(inputs)
	if (locale === "de") return de_servis_s4_li_incident_text(inputs)
	if (locale === "ru") return ru_servis_s4_li_incident_text(inputs)
	return tr_servis_s4_li_incident_text(inputs)
});